<template>
  <span
    class="no-shrink"
    :style="cssVars" />
</template>

<style lang="scss" scoped>
  span {
    display: inline-block;
    border-radius: var(--size);
    width: var(--size);
    height: var(--size);
    background-color: var(--color);
  }
</style>

<script>
/**
 * Component outputs a dot that can be used as a separator.
 * It's best to use it inside flex element and align it on center.
 *
 * @param size Defines the diameter of the dot.
 * @param color Defines the dot color. Accepts hex, RGB(A), HSL(A) notation or keyword.
 */
export default {
  name: 'DotSeparator',
  props: {
    size: {
      type: Number,
      required: false,
      default: 3,
    },
    color: {
      type: String,
      required: false,
      default: '#7c8b91',
    },
  },
  computed: {
    cssVars() {
      return {
        '--size': `${this.size}px`,
        '--color': this.color,
      };
    },
  },
};
</script>
